import React, { useEffect, useState } from 'react';
import styles from './Toast.module.css';

const Toast = ({ toast, onRemove }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    // Trigger entrance animation
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 10);

    return () => clearTimeout(timer);
  }, []);

  const handleRemove = () => {
    setIsExiting(true);
    setTimeout(() => {
      onRemove(toast.id);
    }, 300); // Match CSS animation duration
  };

  const getIcon = (type) => {
    switch (type) {
      case 'success':
        return '✅';
      case 'error':
        return '❌';
      case 'warning':
        return '⚠️';
      case 'info':
      default:
        return 'ℹ️';
    }
  };

  return (
    <div 
      className={`${styles.toast} ${styles[`toast-${toast.type}`]} ${isVisible ? styles['toast-visible'] : ''} ${isExiting ? styles['toast-exiting'] : ''}`}
      onClick={handleRemove}
    >
      <div className={styles['toast-content']}>
        <span className={styles['toast-icon']}>{getIcon(toast.type)}</span>
        <span dangerouslySetInnerHTML={{ __html: toast.message }} className={styles['toast-message']}/>
      </div>
      <button className={styles['toast-close']} onClick={handleRemove}>
        ✕
      </button>
    </div>
  );
};

export default Toast;
